<div class="arrow-up">
    <div class="exclamation-mark">
        !
    </div>
</div>